import { APIMethod, fetchData } from "@client";

export async function sendFeedbackQuery(description) {
  await fetchData("/feedback", APIMethod.POST, { data: { description } });
}
